import React, { useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Grid,
  Button,
  Checkbox,
  ListItemText,
} from "@mui/material";

const PDFFilter = ({ userData, onApplyFilters }) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedProject, setSelectedProject] = useState(
    userData.projectId?.[0] || null
  );
  const [senderName, setSenderName] = useState(null);
  const [vendorName, setVendorName] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState([]); // ✅ ensure default is []
  const [selectedpayment_type, setSelectedpayment_type] = useState([]); // ✅ ensure default is []

  const statusOptions = [
    "Payment done,Awaiting for Bills",
    "Bills Quality Hold",
    "Bills Accepted",
  ];

  const payment_typeOptions = [
    "General",
    "Material and PO Payment",
    "Site Expenditure",
    "UPI payment",
  ];

  const handleApplyFilters = () => {
    const filters = {
      fromDate,
      toDate,
      projectId: selectedProject,
      senderName,
      vendorname: vendorName,
      status: selectedStatus,
      payment_type: selectedpayment_type,
    };
    onApplyFilters(filters);
  };

  const handleStatusChange = (event) => {
    const value = event.target.value;
    setSelectedStatus(value);
  };

  const handlePaymentTypeChange = (event) => {
    const value = event.target.value;
    setSelectedpayment_type(value);
  };

  const handleResetFilters = () => {
    const defaultProject = userData.projectId?.[0] || null;

    setFromDate(null);
    setToDate(null);
    setSelectedProject(defaultProject);
    setSenderName("");
    setVendorName("");
    setSelectedStatus([]); // ✅ fix: set to empty array
    setSelectedpayment_type([]); // ✅ fix: set to empty array

    const resetFilters = {
      fromDate: null,
      toDate: null,
      projectId: defaultProject,
      senderName: null,
      vendorname: null,
      status: [],
      payment_type: [],
    };

    onApplyFilters(resetFilters);
  };

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={3}>
        <TextField
          label="From Date"
          type="date"
          value={fromDate || ""}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="To Date"
          type="date"
          value={toDate || ""}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Select Project</InputLabel>
          <Select
            value={selectedProject}
            onChange={(e) => setSelectedProject(e.target.value)}
            input={<OutlinedInput label="Select Project" />}
          >
            {userData.projectId?.map((project) => (
              <MenuItem key={project} value={project}>
                {project}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Sender Name"
          value={senderName}
          onChange={(e) => setSenderName(e.target.value)}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Vendor Name"
          value={vendorName}
          onChange={(e) => setVendorName(e.target.value)}
          size="small"
          fullWidth
        />
      </Grid>

      {/* Status Single Select */}
      <Grid item xs={12} sm={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Status</InputLabel>
          <Select
            multiple
            value={selectedStatus}
            onChange={handleStatusChange}
            input={<OutlinedInput label="Status" />}
            renderValue={(selected) => selected.join(", ")}
          >
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                <Checkbox checked={selectedStatus?.indexOf(status) > -1} />
                <ListItemText primary={status} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {/* Payment Type Multi Select */}
      <Grid item xs={12} sm={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Payment Type</InputLabel>
          <Select
            multiple
            value={selectedpayment_type}
            onChange={handlePaymentTypeChange}
            input={<OutlinedInput label="Payment Type" />}
            renderValue={(selected) => selected.join(", ")}
          >
            {payment_typeOptions.map((type) => (
              <MenuItem key={type} value={type}>
                <Checkbox checked={selectedpayment_type?.indexOf(type) > -1} />
                <ListItemText primary={type} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {/* Buttons */}
      <Grid item xs={12} sm={6}>
        <Button
          variant="contained"
          onClick={handleApplyFilters}
          fullWidth
          sx={{
            fontWeight: "bold",
            borderRadius: 2,
            py: 1.5,
            textTransform: "none",
            fontSize: "16px",
          }}
        >
          Apply Filters
        </Button>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Button
          variant="outlined"
          onClick={handleResetFilters}
          fullWidth
          sx={{
            fontWeight: "bold",
            borderRadius: 2,
            py: 1.5,
            textTransform: "none",
            fontSize: "16px",
          }}
        >
          Reset Filters
        </Button>
      </Grid>
    </Grid>
  );
};

export default PDFFilter;
